import positionSafetyManage from "../PositionSafetyManage";
import DangerDispose from "../DangerDispose";

export const positionSafetyManageRoute = [
    {
        path: "/newMedia/positionSafetyManage",
        component: positionSafetyManage
    },
    {
        path: "/newMedia/dangerDispose",
        component: DangerDispose
    },
];